export interface IScormApiAdapter {
  LMSInitialize: (param: string) => string
  LMSFinish: (param: string) => string
  LMSGetValue: (name: any) => string
  LMSSetValue: (name: any, value: any) => string
  LMSCommit: (param: string) => string
  LMSGetLastError: () => number
  LMSGetErrorString: (param: any) => string
  LMSGetDiagnostic: (param: any) => string
  getLastError: () => string
  getFullState: () => ScormRuntimeData
  getWritableState: () => WritableScormRuntimeData
}

export interface IScormDataBuilder {
  build: () => ScormRuntimeData | null
}

export type ScormRuntimeData = {
  CoreChildren: string
  Credit: string
  ScoreChildren: string
  LessonMode: string
  StudentDataChildren: string
  Version: string
  StudentId: string
  StudentName: string
  Entry: string
  LaunchData: string
  MasteryScore: string
  ScormLocation: string
  LessonLocation: string
  LessonStatus: string
  ScoreRaw: string
  Exit: string
  SessionTime: string
  SuspendData: string
  TotalTime: string
  [key: string]: any
}

export type WritableScormRuntimeData = Pick<
  ScormRuntimeData,
  | 'LessonLocation'
  | 'LessonStatus'
  | 'ScoreRaw'
  | 'Exit'
  | 'SessionTime'
  | 'SuspendData'
  | 'TotalTime'
>

export type ScormDisplayData = {
  isResponsive: boolean
  canBeResized: boolean
  canBeMaximized: boolean
  width: number
  height: number
}

export type ScormData = {
  scormRuntimeData: ScormRuntimeData
  scormDisplayData: ScormDisplayData
}

export enum CoreExitEnum {
  Default,
  TimeOut,
  Suspend,
  Logout,
}

export const CoreExit: any = {
  [CoreExitEnum.Default]: '',
  [CoreExitEnum.TimeOut]: 'time-out',
  [CoreExitEnum.Suspend]: 'suspend',
  [CoreExitEnum.Logout]: 'logout',

  '': CoreExitEnum.Default,
  'time-out': CoreExitEnum.TimeOut,
  suspend: CoreExitEnum.Suspend,
  logout: CoreExitEnum.Logout,
}

export enum CoreEntryEnum {
  AbInitio,
  Resume,
  Default,
}

export const CoreEntry: any = {
  [CoreEntryEnum.AbInitio]: 'ab-initio',
  [CoreEntryEnum.Resume]: 'resume',
  [CoreEntryEnum.Default]: '',

  'ab-initio': CoreEntryEnum.AbInitio,
  resume: CoreEntryEnum.Resume,
  '': CoreEntryEnum.Default,
}

export enum CoreLessonStatusEnum {
  Passed,
  Completed,
  Failed,
  Incomplete,
  Browsed,
  NotAttempted,
}

export const CoreLessonStatus: any = {
  [CoreLessonStatusEnum.Passed]: 'passed',
  [CoreLessonStatusEnum.Completed]: 'completed',
  [CoreLessonStatusEnum.Failed]: 'failed',
  [CoreLessonStatusEnum.Incomplete]: 'incomplete',
  [CoreLessonStatusEnum.Browsed]: 'browsed',
  [CoreLessonStatusEnum.NotAttempted]: 'not attempted',

  passed: CoreLessonStatusEnum.Passed,
  completed: CoreLessonStatusEnum.Completed,
  failed: CoreLessonStatusEnum.Failed,
  incomplete: CoreLessonStatusEnum.Incomplete,
  browsed: CoreLessonStatusEnum.Browsed,
  'not attempted': CoreLessonStatusEnum.NotAttempted,
}

export enum UpdateMode {
  commit,
  finish,
}

export enum SCORM12Status {
  NotAttempted = 'not attempted',
  Incomplete = 'incomplete',
  Completed = 'completed',
  Failed = 'failed',
  Passed = 'passed',
}

export enum CompletionStatus {
  NotAttempted,
  Inactive,
  Expired,
  Incomplete,
  Completed,
}

export enum SuccessStatus {
  Unknown,
  Failed,
  Passed,
}

export type Scorm2004Statuses = {
  completionStatus: CompletionStatus
  successStatus: SuccessStatus
}
